/* shah */
import React from 'react'

const ZoomIcon = () => {
    return (
        <svg id="SmallBoxSVG-zoom" version="1.0" xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512.000000 512.000000"
            preserveAspectRatio="xMidYMid meet">

            <g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
            >
                <path d="M1790 5105 c-359 -46 -700 -185 -992 -406 -105 -80 -296 -270 -375
-374 -612 -811 -553 -1923 141 -2652 608 -639 1562 -811 2364 -428 114 55 280
157 360 223 l44 35 741 -741 c678 -677 746 -741 787 -752 159 -42 292 91 250
250 -11 41 -75 109 -752 787 l-741 741 35 44 c66 80 160 232 219 353 187 384
249 817 178 1238 -147 862 -818 1527 -1689 1672 -136 23 -428 28 -570 10z
m461 -399 c372 -50 676 -201 945 -470 288 -288 438 -612 476 -1023 26 -282
-32 -592 -158 -850 -157 -320 -436 -600 -754 -755 -453 -222 -984 -221 -1447
3 -304 146 -597 441 -748 752 -342 706 -137 1556 490 2027 242 181 502 283
830 323 75 9 269 5 366 -7z"/>
                <path d="M1977 4250 c-46 -14 -94 -57 -116 -103 -20 -42 -21 -57 -21 -455 l0
-412 -413 0 -414 0 -44 -23 c-24 -13 -57 -43 -74 -66 -26 -37 -30 -51 -30
-111 0 -60 4 -74 30 -111 17 -23 48 -52 70 -63 38 -20 56 -21 457 -24 l417 -3
3 -423 3 -424 30 -43 c87 -123 268 -113 337 20 l28 53 0 409 0 409 409 0 409
0 53 28 c99 52 135 167 82 268 -11 22 -39 53 -62 69 l-43 30 -424 3 -423 3 -3
417 c-3 401 -4 419 -24 457 -41 79 -151 123 -237 95z"/>
            </g>
        </svg>

    )
}

export default ZoomIcon